import React from "react";
import { mediaUrl } from "@/lib/api";

const initials = (name = "") =>
  name.split(" ").filter(Boolean).slice(0, 2).map((n) => n[0]).join("").toUpperCase();

/** Elegant geometric placeholder when no real portrait exists (never fake portraits). */
export const SpeakerAvatar = ({ speaker, className = "", testid }) => {
  const photo = mediaUrl(speaker?.photo);
  if (photo) {
    return (
      <img
        src={photo}
        alt={`Portrait de ${speaker?.name || "intervenant"}`}
        data-testid={testid}
        className={`object-cover w-full h-full ${className}`}
        loading="lazy"
      />
    );
  }
  return (
    <div
      data-testid={testid}
      className={`relative w-full h-full flex items-center justify-center bg-f2b-black overflow-hidden ${className}`}
      role="img"
      aria-label={`Intervenant ${speaker?.name || ""}`}
    >
      <svg className="absolute inset-0 w-full h-full opacity-40" viewBox="0 0 100 100" preserveAspectRatio="none">
        <line x1="0" y1="20" x2="100" y2="0" stroke="#00BEFF" strokeWidth="0.4" />
        <line x1="0" y1="60" x2="100" y2="40" stroke="#00BEFF" strokeWidth="0.4" />
        <line x1="0" y1="100" x2="100" y2="80" stroke="#00BEFF" strokeWidth="0.4" />
        <circle cx="78" cy="26" r="14" fill="none" stroke="#C8A84B" strokeWidth="0.4" />
      </svg>
      <span className="font-display text-white text-3xl md:text-4xl relative z-10 tracking-wide">
        {initials(speaker?.name) || "F2B"}
      </span>
    </div>
  );
};

export default SpeakerAvatar;
